import * as React from "react";
import { styled } from "@mui/material/styles";
import { LinearProgress } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { Messages } from "../messages";

const PREFIX = "BootScreen";

const classes = {
    colorPrimary: `${PREFIX}-colorPrimary`,
    barColorPrimary: `${PREFIX}-barColorPrimary`
};

const Root = styled("div")(() => ({
    [`& .${classes.colorPrimary}`]: {
        backgroundColor: "#bdbdbd"
    },

    [`& .${classes.barColorPrimary}`]: {
        backgroundColor: "#FDB913"
    }
}));

interface BootScreenProps { 
    retrying: boolean;
    viewSettings: () => void;
}

const ProgressBarDiv = styled("div")({
    width: "60%",
    height: "40px",
    margin: "auto",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
});

const StyledText = styled("p")({
    margin: "12px",
    textAlign: "center",
    fontSize: "32px",
});

function BootScreen(props: BootScreenProps): JSX.Element {
    const { retrying } = props;
    
    const message = retrying ? Messages.ConnectivityIssues :  Messages.Connecting;

    return (
        <Root className="background-map">
            <ProgressBarDiv className="progress tc-message-box">
                <LinearProgress
                    variant="indeterminate"
                    classes={{ colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary }}
                />
                <StyledText><FormattedMessage {...message} /></StyledText>
            </ProgressBarDiv>
        </Root>
    );
}

export default (BootScreen);

